'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'poo-storm';
var width = 512;
var height = 512;
var aliases = ["poo-bolt"];
var unicode = 'f75a';
var svgPathData = ['M128 399.4c0 9.2 7.4 16.6 16.6 16.6l61.8 0-31.2 104.1c-3.6 11.9 5.3 23.9 17.8 23.9 4.6 0 9-1.7 12.4-4.7L346.5 412.9c3.5-3.1 5.5-7.6 5.5-12.4 0-9.2-7.4-16.6-16.6-16.6l-61.8 0 31.2-104.1c3.6-11.9-5.3-23.9-17.8-23.9-4.6 0-9 1.7-12.4 4.7L133.5 387.1c-3.5 3.1-5.5 7.6-5.5 12.4z', 'M254.4-26.1c3.5-4.3 9-6.5 14.5-5.7 46.9 6.3 83.1 46.6 83.1 95.2 0 5.7-.5 11.2-1.4 16.6l9.4 0c48.6 0 88 39.4 88 88 0 14.8-3.7 28.8-10.2 41.1 42 6.6 74.2 43 74.2 86.9 0 48.6-39.4 88-88 88l-26.2 0c-7.1-26.8-31-46.8-59.8-47.9l12.7-42.4c12.8-42.7-19.2-85.7-63.7-85.7-16.4 0-32.2 6-44.4 17L101.5 351.3c-9.7 8.7-16.5 20.1-19.6 32.5-45.8-3.1-81.9-41.2-81.9-87.8 0-43.9 32.1-80.3 74.2-86.9-6.5-12.3-10.2-26.2-10.2-41.1 0-48.6 39.4-88 88-88l24 0c24 0 44.2-6.2 58.1-17 13.4-10.4 21.9-25.9 21.9-47.6 0-9.2-1.5-18-4.3-26.1-1.8-5.2-.8-11.1 2.8-15.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPooStorm = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;